import React, { Suspense } from 'react'
import { Switch, Route } from 'react-router-dom'
import AppLoader from 'screens/appLoader'
import appRoutes from 'routes/appRoutes'
const Layout = React.lazy(() => import(`screens/layout`))

export default function ThemePrivate({ userType }) {
  const routes = appRoutes[userType]
  return (
    <Suspense fallback={<AppLoader />}>
      <Layout routes={routes} role={userType}>
        <Switch>
          {routes.map(({ exact = true, ...routeProps }) => (
            <Route {...routeProps} exact={exact} />
          ))}
        </Switch>
      </Layout>
    </Suspense>
  )
}
